import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TimeBudgetUtils } from '@/core/utils/time-budget-utils';

/** e.g. "05h 30m / 20h" with a bar that turns red when the budget is over. */
@Component({
    selector: 'app-time-budget-bar',
    templateUrl: './time-budget-bar.component.html',
    styleUrls: ['./time-budget-bar.component.scss'],
    standalone: false,
})
export class TimeBudgetBarComponent {
    @Input({ required: true }) usedSeconds!: number;
    @Input({ required: true }) budgetSeconds!: number;

    constructor(private readonly translate: TranslateService) {}

    public get budgetHours(): string {
        return TimeBudgetUtils.formatHours(this.budgetSeconds, this.translate.getCurrentLang());
    }

    public get percent(): number {
        return this.budgetSeconds > 0 ? Math.min(100, (this.usedSeconds / this.budgetSeconds) * 100) : 0;
    }

    public get over(): boolean {
        return this.usedSeconds > this.budgetSeconds;
    }
}
